import { deepCopy } from "@perxis-auto/shared";
import "../model/index.js";
import { getPartiallyExtendedItems } from "./getPartiallyExtendedItems.js";
import { modifyReferences } from "./modifyReferences.js";
import { actions } from "../model/slice.js";
async function getExtendedItems(api, items, options) {
  const state = api.getState();
  const { partiallyExtendedItems, nonExtendedReferences, uniqueNonExtendedReferences } = getPartiallyExtendedItems(
    state.reference,
    deepCopy(items),
    options
  );
  if (uniqueNonExtendedReferences.length) {
    await api.dispatch(
      actions.fetchReferences({
        envId: state.config.envId,
        spaceId: state.config.spaceId,
        references: uniqueNonExtendedReferences
      })
    ).unwrap();
    const stateWithUniqueRefs = api.getState();
    modifyReferences(stateWithUniqueRefs.reference, nonExtendedReferences);
  }
  return partiallyExtendedItems;
}
export {
  getExtendedItems
};
